<template>
    <el-dialog
            title="新增领域"
            :visible="showField"
            :close-on-click-modal="!showField"
            :before-close="close"
            width="600px"
    >
        <div class="Field">
            <el-form ref="form" :model="FiledModel" label-width="80px" :rules="rules">
                <el-form-item label="领域名称" prop="name">
                    <el-input v-model.trim="FiledModel.name" maxlength="100" placeholder="请输入领域名称，不超过100字" class="edit_input" style="width: 410px"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="description" class="m-t-20">
                    <el-input type="textarea" v-model.trim="FiledModel.description" maxlength="1000" placeholder="请输入备注，不超过1000字" class="edit_input" style="width: 410px"></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                <el-button type="primary" @click="push('form')">确认</el-button>
            </div>
        </div>

    </el-dialog>
</template>

<script>
    import { addproduct } from "@/service/dataFrame";
    import { getStorageUserRoleId } from '@/utils/store'
    export default {
        name: "addField",
        data(){
            return{
                rules:{
                    name: [{required:true, message: '请输入领域名称！', trigger: 'change'}],
                },
                showField:true,
                FiledModel:{
                    name:'',
                    description:'',
                }
            }
        },
        methods:{
            close(){
                this.$emit("close")
            },
            push(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.addField();
                    }
                })
            },
            addField(){
                let param={
                    description:this.FiledModel.description,
                    levelType:0,
                    name:this.FiledModel.name,
                    userId:getStorageUserRoleId()
                }
                addproduct(param).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$emit("close")
                    this.$message.success("新增成功")
                    this.$emit("refreshList")
                })
            }
        },
        mounted() {
            // let param = JSON.parse(JSON.stringify(this.currentParam))
            // console.log("param",param)
            // if (param){
            //     this.FiledModel={
            //         name:param.productDomainName,
            //         description:param.description,
            //     }
            // }
        }
    }
</script>

<style lang="scss">
    .Field{
        .m-t-20{
            margin-top: 20px;
        }
        .el-textarea__inner{
            min-height: 120px!important;
            font-family: Microsoft YaHei;
        }
    }

</style>
